/* Customized for KLP */
class ProductOptions extends HTMLElement {
  constructor () {
    super()
  }
  connectedCallback () {
    //window.console.log('~~~~ ProductOptions connectedCallback');
      this.available_variants = [];
      this.container = this.querySelector('.product-options--container');
      this.masterSku = this.getAttribute('data-master-sku');
      this.first_variant = JSON.parse(this.querySelector('[id*=variant-first--json]').innerHTML);
      this.inputs = this.container.querySelectorAll('[data-item="disclosure"], [data-item="radio"]');
      this.is_product_page = null !== this.closest('.product-page--root');
      this.option_values = [];
      this.size_chart = this.querySelector('.product-options--option .product-size-chart--root');
      this.variants = JSON.parse(this.querySelector('[id*=variant--json]').innerHTML);
    
      this.getVariantOptions();
      this.hideOptions(this.first_variant, 0);
      this.disableEmptyOptions();
      this.optionChangeListener();
      if (this.size_chart) {
        this.moveSizeChart();
      }

      //window.console.log('this.masterSku=', this.masterSku);
      // Load other colors linked by MasterSku tag
      if (this.masterSku){
        this.initPDPOtherColors();
      }
  }
  initPDPOtherColors() {
      //window.console.log('initPDPOtherColors');
      this.pdpAllVariants = [];
      this.pdpAllProdsForSku = [];
      this.form = this.closest('.js-product-addtocart-form');
      this.pdpColorOptionDiv = this.querySelector('.product-options--option.option-color');
      this.hideOOSColors = 'true' === this.pdpColorOptionDiv.getAttribute('data-hide-oos-swatches');
      //window.console.log('form', this.form);
      //window.console.log('masterSku', this.masterSku);
      if (this.masterSku) {
        this.loadByMasterSku();
      } else {
        window.console.log('~~~~~ NO MASTER SKU')
      }
  }
  loadByMasterSku() {     
    //window.console.log('loadByMasterSku');
      var fetchUrl = theme.urls.all_products_collection.concat("/MasterSku:".concat(this.masterSku), "?view=data");
    //window.console.log('mastersku url', fetchUrl);
      fetch(fetchUrl)
        .then((response) => response.json())
        .then((data) => this.pdpBuildColorSwatches(data));    
  }
  pdpBuildColorSwatches(data) {
    //window.console.log('pdpBuildColorSwatches', data);
    /*window.trigger(`theme:producttile:${this.masterSku}:variantsLoaded`, {
      products: data.products
    });*/
    this.pdpAllProdsForSku = data.products;

    // json for gtm add to cart
    var jsonElement = document.createElement("script");
    jsonElement.id = "product-mastersku--json";
    jsonElement.type = "application/json";
    jsonElement.innerHTML = JSON.stringify(data.products);    
    this.form.appendChild(jsonElement);

    var radiosRoot = this.pdpColorOptionDiv.querySelector('.radios--root');
    var is_swatches = 'true' === radiosRoot.getAttribute('data-is-swatches');
    var display_swatches_only = 'true' === radiosRoot.getAttribute('data-display-only');
    var colorUL = this.pdpColorOptionDiv.querySelector('.radios--container');
    var selectedRadio = this.pdpColorOptionDiv.querySelector('.radios--input:checked');
    var currentColor = selectedRadio.value;
    //window.console.log('currentColor', currentColor);
    var radiosName = colorUL.getAttribute('aria-labelledby');

    // loop through the products returned from the MasterSku call
    for (var i = 0; i < data.products.length; i++) {
      var prod = data.products[i];
      if (!('selectedColor' in prod) || prod.selectedColor == '') {
        continue;
      }
      var prodSwatchUrl = prod.url;
      if (this.is_product_page) {
        try {
          var temp = window.location.pathname.split('/');
          temp = temp.filter((str) => str !== '');        
          if (temp.indexOf('collections') > -1) {
            var productsIndex = temp.indexOf('products');          
            temp = temp.slice(0, productsIndex);            
            var temp2 = prod.url.split('/');
            temp2 = temp2.filter((str) => str !== '');  
            var urlarr = temp.concat(temp2);          
            var newurl = urlarr.join('/');            
            prodSwatchUrl = '/' + newurl;
          }
        } catch (ex) {}
      }

      this.pdpAllVariants.push.apply(this.pdpAllVariants, prod.variants);

      if (prod.selectedColor == currentColor) {
        selectedRadio.closest('.radios--main').setAttribute('data-sort', i);
      } else { 
        if (!prod.available && this.hideOOSColors) {
            continue;
        }
        
        // build each new swatch
        var radioId = radiosName + '-' + prod.selectedColor.handleize();
        //window.console.log('radioId', radioId);
               
        var newRadio = document.createElement("input");
        newRadio.type = 'radio';
        newRadio.classList.add('radios--input');
        newRadio.setAttribute('data-item', 'radio');
        newRadio.setAttribute('data-url', prodSwatchUrl);      
        newRadio.setAttribute('name', radiosName);
        newRadio.setAttribute('id', radioId)
        newRadio.setAttribute('value', prod.selectedColor);
        
        var newLabel = document.createElement("label");
        newLabel.classList.add('radios--swatch-button');
        newLabel.setAttribute('data-item', 'swatch');
        newLabel.setAttribute('for', radioId);
        newLabel.setAttribute('aria-label', prod.selectedColor);
        newLabel.setAttribute('data-url', prodSwatchUrl);      
        
        var newLI = document.createElement("div");
        newLI.classList.add('radios--main');
        newLI.setAttribute('data-sort', i);
        
        newLI.appendChild(newRadio);
        newLI.appendChild(newLabel);

        // append the new swatch to the list
        colorUL.appendChild(newLI);
      }
  
      theme.utils.setSwatchColors(colorUL.querySelectorAll('input'));      
    }
    //window.console.log('pdpAllVariants', this.pdpAllVariants);

    // Sort the color swatches
    var unsorted = colorUL.querySelectorAll('.radios--main');
    var unsortedArr = Array.from(unsorted);
    var sorted = unsortedArr.sort(function(a, b) {
      return +a.dataset.sort - +b.dataset.sort;
    });
    sorted.forEach(k => colorUL.appendChild(k))

    // include other variants in existing json element
    var jsonElement = this.querySelector('[id*=variant--json]'); //$('[id*=variant--json]');
    var allvariantsJson = JSON.stringify(this.pdpAllVariants);
    //window.console.log('allvariantsJson', allvariantsJson);
    jsonElement.innerHTML = allvariantsJson;
    
    // trigger the attributeChangedCallback
    this.setAttribute('data-variants-added', true);
    
  }
  disconnectedCallback () {
    this.inputs.off('change.ProductOptions')
  }
  static get observedAttributes () {
    return ['data-variants-added']
  }
  attributeChangedCallback (t, i, e) {
    //window.console.log('attributeChangedCallback', t, i, e);
    if ('true' == e) {
      // get the new list of variants
      this.variants = JSON.parse(this.querySelector('[id*=variant--json]').innerHTML);
      //window.console.log('attributeChangedCallback, this.variants.length=', this.variants.length);
      this.available_variants = [];
      this.option_values = [];

      // get the added inputs
      this.inputs = this.container.querySelectorAll('[data-item="disclosure"], [data-item="radio"]');

      // rebuild options
      this.getVariantOptions();
      this.disableEmptyOptions();
      
      // rebind change event
      this.inputs.off('change.ProductOptions');
      this.optionChangeListener();
        
    }
  }
  getVariantOptions () {
    //window.console.log('getVariantOptions, this.variants.length=', this.variants.length);
    if (
      (this.variants.forEach(
        t => t.available && this.available_variants.push(t.options)
      ),
      0 < this.available_variants.length)
    ) {
      for (let i = 0; i < this.available_variants[0].length; i++) {
        this.option_values[i] = [
          ...new Set(this.available_variants.map(t => t[i]))
        ]
      }
    }
  }
  disableEmptyOptions () {
    const e = this.option_values.flat()
    this.container
      .querySelectorAll('.radios--input, .disclosure--option')
      .forEach(t => {
        var i = this.getOptionValue(t)
        e.includes(i) || t.setAttribute('data-empty', !0)
      })
  }
  optionChangeListener () {
    this.inputs.on('change.ProductOptions', ({ target: inputEl }) => {
      //window.console.log('ProductOptions input change', inputEl);

      var is_color = null !== inputEl.closest('.product-options--option.option-color');
      //window.console.log('is_color', is_color);
      
      const arr1 = [];
      this.container.querySelectorAll('[data-item="disclosure"], [data-item="radio"]:checked').forEach(t1 => {
          var i = t1.closest('.product-options--option').dataset.index
          arr1.push({ index: i, value: t1.value })
        });
      this.hideOptions(
          arr1.map(j => j.value),
          inputEl.closest('.product-options--option').index()
      );
      
      let foundProd = false;
      this.variants.every(eachVariant => {
        let e = true;
        return (
          arr1.forEach(b => {
            e = e && eachVariant.options[b.index] === b.value
          }),
          !e || ((foundProd = eachVariant), !1)
        )
      });
      
      //window.console.log('foundProd', foundProd);
      //this.updateVariant(foundProd);

      if (is_color) {      
        var href = inputEl.dataset['url'];
        //window.console.log('ProductOptions input data-url', href);
        this.updateVariant(foundProd, href);
        
        // load selected color
        new Promise(() => {
          this.refreshProductSections(href, foundProd)
        }).catch((err) => {
          console.log(err)
        });
      } else {
        this.updateVariant(foundProd, null);
      }
    })
  }
  updateVariant (t, url) {
      //window.console.log('updateVariant ', t);
    this.is_product_page && this.updateHistoryState(t.id, url);
    
      window.trigger(`theme:product:${this.dataset.id}:variantChanged`, {
        variant: t
      });
  }
  updateHistoryState (t, url) {
    //window.console.log('updateHistoryState ', t, url);
    if (url) {
      history.replaceState({ path: url }, '', url)
    } else {
      let i = '' + location.origin + location.pathname
      t && (i += '?variant=' + t), history.replaceState({ path: i }, '', i)
    }
  }
  refreshProductSections (link, variant) {    
    var variantId = variant.id;
    //window.console.log('refreshProductSections', link, variantId);
    var __this = this;
    
    //window.console.log('refreshProductSections', this.pdpAllProdsForSku);
    
    //var selectedProduct = this.pdpAllProdsForSku.find(p => link.indexOf(p.handle) > -1);
    //window.console.log('selectedProduct', selectedProduct);

    if (this.is_product_page) {
      /* 
       * PDP reload sections 
       */
      var jsSections = document.querySelectorAll('.js-smp-reload');

      var appsRoot = document.querySelector('#main-content').querySelector('.apps--root');
      var appsSectionId = (appsRoot) ? appsRoot.dataset['sectionId'] : null;
      var appSections = (appsSectionId) ? document.querySelectorAll('#shopify-section-'+appsSectionId) : [];
      
      //var reloadSections = document.querySelectorAll('.js-smp-reload');
      var reloadSections = (appSections.length) ? [...jsSections, ...appSections] : jsSections;
      if (reloadSections.length) {
        reloadSections.forEach((sectionItem, i) => {        
          // get section id
          const sectionId = sectionItem.id.replace('shopify-section-', '');
          //console.log('sectionId', sectionId);
          const newUrl = link + `?section_id=` + sectionId;
          //console.log('get newUrl', newUrl);

          window
            .fetch(newUrl)
            .then()
            .then((_) => _.text())
            .then((html) => {
              var d = theme.utils.parseHtml(html, '.shopify-section')
              //window.console.log('fetched new html', d);
    
              sectionItem.replaceWith(d);
            })
            .then((_) => {
              // anything next 
              if (typeof yotpoWidgetsContainer != 'undefined') {
                yotpoWidgetsContainer.initWidgets();
              }
            });
        });
      }
    } else {
      /* 
       * Quick add reload form 
       */
      var query = '?section_id=product--quick-add--form&variant=' + variantId;
      const newUrl = link + query;
      window
        .fetch(newUrl)
        .then()
        .then((_) => _.text())
        .then((html) => {
          var d = theme.utils.parseHtml(html, '.product--quick-add--form')
          //window.console.log('fetch new html', d);

          // update .product--quick-add--title parent a href
          // replace .product-media--variants--root
          // replace .js-product-addtocart-form

          var existingContainer = __this.closest('.product--quick-add--form');

          // product--quick-add--title
          var newLink = d.querySelector('.product--quick-add--title').parentNode;
          existingContainer.querySelector('.product--quick-add--title').parentNode.replaceWith(newLink);
          
          var newMedia = d.querySelector('.product-media--variants--root');
          if (newMedia) {
          //window.console.log('newMedia', newMedia);
            existingContainer.querySelector('.product-media--variants--root').replaceWith(newMedia);
          }

          var newSlideshow = d.querySelector('.product-page--carousel');
          var existingSlideshow = existingContainer.querySelector('.product-page--carousel');
          if (newSlideshow && existingSlideshow) {
          //window.console.log('newSlideshow', newSlideshow);
            var slideshowContainer = existingSlideshow.parentNode;
            
            slideshowContainer.style.height = existingSlideshow.offsetHeight + 'px';
            slideshowContainer.setAttribute('data-loading', 'true')
            existingSlideshow.replaceWith(newSlideshow);
            setTimeout(function () {
                slideshowContainer.removeAttribute('data-loading');
            }, 750);
          }

          var newForm = d.querySelector('.js-product-addtocart-form');
          //window.console.log('newForm', newForm);

          //__this.form.parentNode.replaceChild(newForm, __this.form);
          __this.form.replaceWith(newForm);

        })
        .then((_) => {
              // anything next  
        });
    }
  }
  hideOptions (a, i) {
    //window.console.log('hideOptions', a, i);
    //window.console.log('option_values', this.option_values);
    const s =
      0 === this.option_values.length
        ? []
        : a.map((t, e) => {            
            //window.console.log('a.map', t, e);
            return this.option_values[e].filter(t => {
              const i = [...a]
              return (
                (i[e] = t),
                this.available_variants.some(t => t.join(',') === i.join(','))
              )
            })
          }
          );
    this.container.childNodes.forEach((t, e) => {
      e != i &&
        t.querySelectorAll('.radios--input, .disclosure--option').forEach(t => {
          var i = this.getOptionValue(t)
          t.setAttribute('data-unavailable', s[e] && !s[e].includes(i))
        })
    })
  }
  getOptionValue (t) {
    return t.getAttribute('data-value') ? t.getAttribute('data-value') : t.value
  }
  moveSizeChart () {
    this.size_chart.parentNode.querySelector('label').parentNode.appendChild(this.size_chart);
    this.size_chart.removeAttribute('style');
  }
}
const productOptionsEl = customElements.get('product-options-root')
productOptionsEl || customElements.define('product-options-root', ProductOptions)
